import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { api } from "../../environments/environment";
import { Message } from "../service/message.service";
import { RestService } from "../service/rest.service";
import { LoaderService } from "../service/loader.service";

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styles: [],
  standalone: false,
})
export class RegistrationComponent implements OnInit {
  constructor(
    private router: Router,
    private message: Message,
    private rest: RestService,
    private loader: LoaderService
  ) {}

  credentials: any = {};
  showPassword = false;
  acceptPrivacy = false;
  acceptTerms = false;

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const referral = params.get("referral");
    if (referral) {
      this.credentials.referral = referral;
    }
  }

  checkboxTerms(event: any) {
    this.acceptTerms = event.checked;
  }

  checkboxprivacy(event: any) {
    this.acceptPrivacy = event.checked;
  }

  register() {
    if(this.acceptTerms && this.acceptPrivacy && this.checkCredentials()){
    this.loader.on();
    let params = this.credentials
    delete params.confirmPassword
    this.rest.post(api.endpoint.register, params).subscribe({
      next: () => {
        this.loader.off(true);
        this.message.showMessage("Ti sei registrato con successo ora, verifica l'email e potrai loggarti", "success");
        // this.rest.setToken(value.access_token);
        this.router.navigate(["login"]);
      },
      error: (value:any) => {
        this.loader.off(true);
        this.message.showMessage(value.message, "error");
      },
    });
  }else{
    this.message.showMessage('Prima di proseguire devi spuntare le checkbox e compilare tutti i campi','error')
  }
  }

  checkCredentials() {
    return (
      this.credentials.firstName &&
      this.credentials.lastName &&
      this.credentials.email &&
      this.credentials.password &&
      this.credentials.confirmPassword &&
      this.credentials.password === this.credentials.confirmPassword
    );
  }

  backToLogin() {
    this.router.navigate(["/login"]);
  }
  showMessage(status: string, message: string) {
    this.message.showMessage(message, status);
  }

    checkPassword(password:string) {
  if (password.length < 8) 
    return "La password deve contenere almeno 8 caratteri.";
  
  if (!/[A-Z]/.test(password)) 
    return "La password deve contenere almeno una lettera maiuscola.";
  
  if (!/[a-z]/.test(password)) 
    return "La password deve contenere almeno una lettera minuscola.";
  
  if (!/[0-9]/.test(password)) 
    return "La password deve contenere almeno un numero.";
  
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/.test(password)) 
    return "La password deve contenere almeno un carattere speciale.";
  
  return "✅ La password è sicura!";
}
}
